import styled from 'styled-components';
import { Modal } from 'antd';

export const ModalBorder = styled(Modal)`
	.ant-modal-content {
		border-radius: 15px;
	}
`;
